import { Twitter, Github, Mail } from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white mt-20 relative overflow-hidden">
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-brand-600/10 via-accent-600/10 to-brand-600/10"></div>
      
      <div className="container mx-auto px-4 py-16 relative">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-gradient-to-br from-brand-500 to-accent-500 p-2 rounded-xl shadow-lg">
                <img src="/logo.svg" alt="Logo" className="w-6 h-6 invert" />
              </div>
              <span className="text-2xl font-black gradient-text">Domain Brainstorm</span>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              Find the perfect domain name for your project. Free, fast, and unlimited domain checking with AI-powered suggestions.
            </p>
          </div>

          {/* Features */}
          <div>
            <h3 className="font-semibold mb-4">Features</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Domain Suggestions</li>
              <li>Availability Checking</li>
              <li>Multiple TLD Support</li>
              <li>Bulk Domain Check</li>
              <li>Real-time Results</li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <a href="#" className="hover:text-white transition-colors">API Documentation</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Domain Tips</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Registrar Partners</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a 
                href="https://twitter.com/domainbrainstorm" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="https://github.com/yourusername/domain-brainstorm" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors"
              >
                <Github className="w-5 h-5" />
              </a>
              <a 
                href="mailto:hello@domainbrainstorm.com"
                className="text-gray-400 hover:text-primary-400 transition-colors"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
            <p className="text-xs text-gray-500 mt-4">
              Built with ❤️ using Cloudflare Workers
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>&copy; 2025 Domain Brainstorm. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
